const customeStyle = 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px; border: 1px solid white; width: 1110px;'+
'margin: 0px 15px; }'+
'figure > figcaption {  ' +
'font-style: italic; ' +
'margin: 8px 0 0;' +
'padding: 0 30px;' +
'font-size: 14px;' +
'line-height: 22px;' +
'text-align: center;' +
'color: #666;' +
'}'+
'figure { display: table; margin: 1rem auto }'+
'img { max-width:100%; }'
export default customeStyle
